interface Configs {
  name: string;
}

const configs: Configs = {
  name: "Mortgage Notes (Trust Deeds)",
};

export default configs;
